import "./overlay.scss";
import { type FC } from "react";
import { useShopfrontSelector } from "../../_Bootstrap/hooks";
import { useShowMenu } from "../../Utilities/Hooks/ShowMenu";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

const Overlay: FC<{
    visible?: boolean;
}> = ({ visible }) => {
    const stateVisible = useShopfrontSelector(
        state => typeof visible === "undefined" ? state.layout.body.overlay : visible
    );
    const loading = useShopfrontSelector(state => state.layout.body.loading);

    const forceMenu = useShowMenu();

    const classes = [ "overlay" ];

    if(stateVisible) {
        classes.push("visible");
    }

    if(forceMenu) {
        classes.push("menu-force");
    }

    let loadingComponent = null;

    if(loading) {
        classes.push("loading");

        loadingComponent = (
            <FontAwesomeLight icon="spinner-third" spin />
        );
    }

    return (
        <div
            className={classes.join(" ")}
            onClick={(e): void => {
                if(loading) {
                    e.stopPropagation();
                }
            }}
        >
            {loadingComponent}
        </div>
    );
};

export default Overlay;
